import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "radioTune"
const RadioTuneIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.695 1.564a.75.75 0 0 1 .61 1.371L8.035 7.5H21A1.5 1.5 0 0 1 22.5 9v11.25a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5V9A1.5 1.5 0 0 1 3 7.5h1.34zm-2.32 9.31a3.75 3.75 0 1 0 0 7.501 3.75 3.75 0 0 0 0-7.5M5.25 15.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zm0-2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5zm0-2.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5z"
            clipRule="evenodd"
          />
          <path d="M21.75 5.25a1.5 1.5 0 0 1-1.5 1.5H18v-1.5z" />
        </svg>
      }
    </span>
  )
}
export default RadioTuneIcon
